import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
const base_url = process.env.REACT_APP_API_URL;

const DepositHistory = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [recharge, setRecharge] = useState([]);
  const [filteredRecharge, setFilteredRecharge] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [statusType, setStatusType] = useState("");

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };


  const handleChange = (e) => {
    const inputValue = e.target.value;
    const filteredData = recharge.filter((value) =>
      value.id_order.includes(inputValue) || value.phone.includes(inputValue)
    );
    setFilteredRecharge(filteredData);
  };

  const handleFilter = () => {
  const start = startDate ? new Date(startDate + "T00:00:00") : null;
  const end = endDate ? new Date(endDate + "T23:59:59") : null;

  const filtered = recharge.filter((item) => {
    const itemTime = new Date(item.time.replace(" ", "T")); // Convert "YYYY-MM-DD HH:MM:SS" to ISO format
    const matchStart = start ? itemTime >= start : true;
    const matchEnd = end ? itemTime <= end : true;
    const matchStatus = statusType ? String(item.status) === statusType : true;
    return matchStart && matchEnd && matchStatus;
  });

  setFilteredRecharge(filtered);
};


  const withdrawData = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await axios.post(
        base_url + "/api/webapi/admin/recharge",
        { auth },
        { headers: { "content-type": "application/json" } }
      );

      const data = response?.data.datas2 || [];
      if (response?.data.status) {
        setRecharge(data);
        setFilteredRecharge(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    withdrawData();
  }, [refresh]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="wrapper">
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />

      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      <div
        className={`content-wrapper ${
          !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
        }`}
        style={{
          marginLeft: !isMobile && isSidebarOpen ? "" : "0",
          transition: "margin-left 0.3s ease",
        }}
      >
        <section className="content mt-2">
          <div className="d-flex flex-wrap justify-content-between mt-2 p-1 tophead">
            <div className="d-flex align-items-center cursor-pointer justify-content-center">
              <div className="top px-2 fs-3">Deposit History</div>
            </div>
            <button
              type="button"
              className="btn btn-sm btn-primary refreshButton px-3 py-1 m-2"
              onClick={() => setRefresh(!refresh)}
            >
              Refresh
            </button>
          </div>

          <div className="pt-3">
            <div className="input-group mb-3">
              <input
                type="text"
                className="form-control p-3 mt-1"
                placeholder="Enter Account or Transaction Id To Search"
                onChange={handleChange}
              />
              <button type="button" className="btn btn-outline-secondary mt-0">
                <FontAwesomeIcon
                  icon={faSearch}
                  style={{ fontSize: "15px", color: "#555" }}
                />
              </button>
            </div>

            <div className="row mb-3">
              <div className="col-md-3">
                <label className="form-label">From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>

              <div className="col-md-3">
               <label htmlFor="status" >Status Type</label>
                <select
                className="form-select"
                value={statusType}
                onChange={(e) => setStatusType(e.target.value)}
                // style={{ minWidth: 150 }}
                id="status"
                >
                  <option value="">All Status</option>
                  <option value="1">Success</option>
                  <option value="0">Reject</option>
                </select>
              </div>

              {/* <div className="col-md-3">
                <label className="form-label">Status Type</label>
                <select
                  className="form-control"
                  value={statusType}
                  onChange={(e) => setStatusType(e.target.value)}
                >
                  <option value="">All</option>
                  <option value="1">Success</option>
                  <option value="2">Reject</option>
                </select>
              </div> */}

              <div className="col-md-3 d-flex align-items-end">
                <button className="btn btn-primary me-2" onClick={handleFilter}>
                  Filter
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setStartDate("");
                    setEndDate("");
                    setStatusType("");
                    setFilteredRecharge(recharge);
                  }}
                >
                  Clear
                </button>
              </div>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-hover datatable table-striped mt-4">
              <thead className="bg-dark text-white">
                <tr>
                  <th className="text-center">ID</th>
                  <th className="text-center">Account</th>
                  <th className="text-center">Type</th>
                  <th className="text-center">Amount</th>
                  <th className="text-center">Transaction Id</th>
                  <th className="text-center">Status</th>
                  <th className="text-center">Time</th>
                </tr>
              </thead>
              <tbody>
                {filteredRecharge.map((draw) => (
                  <tr key={draw.id}>
                    <td className="text-center">{draw.id}</td>
                    <td className="text-center">{draw.phone}</td>
                    <td className="text-center">{draw.type}</td>
                    <td className="text-center">{draw.money}</td>
                    <td className="text-center">{draw.id_order}</td>
                    <td className="text-center">
                      <span
                        style={{
                          backgroundColor: draw.status === 1 ? "green" : "red",
                          color: "white",
                          padding: "4px 12px",
                          borderRadius: "0.5rem",
                        }}
                      >
                        {draw.status === 1 ? "Success" : "Reject"}
                      </span>
                    </td>
                    <td className="text-center">{draw.time}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  );
};

export default DepositHistory;
